module.exports = __webpack_public_path__ + "static/img/2.fc262ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/su/2.jpg
// module id = TK08
// module chunks = 1